import React, { } from 'react'
import { Typography, IconButton, Tooltip, Box } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useTheme } from '@material-ui/core/styles';
import { useLayout, UPDATE_LAYOUT } from '../../../state/layoutState';


export const Seperator = (props) => {
    const theme = useTheme();

    let [layout, layoutDispatch] = useLayout();
    if (props.id);
    const target = `expandInput_${props.id}`;
    let expanded = layout[target];

    const toggle = () => {
        let data = {};
        data[target] = !expanded
        layoutDispatch({ type: UPDATE_LAYOUT, data })
    }

    const autoOpen = () => {
        if(!expanded) toggle() 
    }


    const seperator = {
        height: 1,
        backgroundColor: theme.palette.primary.main,
        opacity: 0.5,
        //margin: '5px 0px 0 0',
        margin: '0px 0 6px 0px',
        marginTop: `${props.id ? -2: 3}px`,
    };

    const color = props.active ? theme.palette.secondary.main : theme.palette.primary.main;
    const colorTheme = props.active ? "secondary" : "primary";


    return (
        <Box style={{ paddingTop: 0, paddingBottom:2, cursor: 'pointer'}} onClick={() => toggle()} onFocus={() => autoOpen()}  >
            <Tooltip title={expanded ? "" : "Click to edit"} placement="top" arrow >
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
                <Box display="flex" flexDirection="row" alignItems="center" flex={1}>
                    {props.id && (
                        <IconButton style={{ padding: 0, paddingLeft: 0, paddingRight: 5, paddingBottom: 0 }} color={colorTheme} aria-label={`expand ${target}`} >
                            {expanded ? (
                                <ExpandLessIcon />
                            ) : (
                                <ExpandMoreIcon />
                                )}
                        </IconButton>
                    )}

                    <Box>
                        <Typography variant='h3' disabled style={{ marginLeft: 0, lineHeight: 0.95, paddingBottom:4, color:color }}>
                            {props.label}
                        </Typography>
                    </Box>
                    {props.id && (
                    <Box display="flex" flexGrow={1} flexDirection="row" justifyContent="flex-end">
                        <Typography variant='body2' style={{ marginLeft: 10, lineHeight: 0.95}}>
                        {expanded ? ( `Hide`) : ( `Edit`  )}
                        </Typography>
                    </Box>
                    )}
                </Box>
            </Box>
            </Tooltip>
            <div style={seperator} />
        </Box>
    )
}

export default Seperator;
